/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum FinnairItineraryNote {
  REQUIRES_AIRPORT_CHANGE = 'REQUIRES_AIRPORT_CHANGE',
  HAS_NEXT_DAY_TRANSFER = 'HAS_NEXT_DAY_TRANSFER',
  HAS_LONG_TRANSFER = 'HAS_LONG_TRANSFER'
}

